import { render, staticRenderFns } from "./ModalSelectMedia.vue?vue&type=template&id=4c88f71a&scoped=true"
import script from "./ModalSelectMedia.vue?vue&type=script&lang=js"
export * from "./ModalSelectMedia.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectMedia.vue?vue&type=style&index=0&id=4c88f71a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c88f71a",
  null
  
)

export default component.exports